// extracted by mini-css-extract-plugin
module.exports = {"root":"MinimalLoader__root___3GCLY","fade-in":"MinimalLoader__fade-in___VFwMP"};